import { SVGAttributes } from 'react';

export function DeviceIpIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="174px"
      height="220px"
      viewBox="-0.5 -0.5 174 220"
      {...props}
    >
      <g>
        <g data-cell-id="0">
          <g data-cell-id="1">
            <g data-cell-id="43s24t3kMvA4kIPissoO-1" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-3" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-4" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-5" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-7" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-8" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-12" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-13" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-14" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-15" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-16" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-17" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-18" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-19" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-20" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-21" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-22" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-29">
              <g data-cell-id="43s24t3kMvA4kIPissoO-6" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-27" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-9" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-28" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-33" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-36" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-37" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-38" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-44">
              <g data-cell-id="43s24t3kMvA4kIPissoO-42" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-43" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-47">
              <g data-cell-id="43s24t3kMvA4kIPissoO-45" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-46" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-48">
              <g data-cell-id="43s24t3kMvA4kIPissoO-39" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-41" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-49">
              <g data-cell-id="43s24t3kMvA4kIPissoO-50" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-51" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-52" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-53">
              <g>
                <ellipse
                  cx="81"
                  cy="20"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-54">
              <g>
                <ellipse
                  cx="121"
                  cy="20"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-55">
              <g>
                <ellipse
                  cx="161"
                  cy="20"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-56">
              <g>
                <ellipse
                  cx="81"
                  cy="110"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-57">
              <g>
                <ellipse
                  cx="121"
                  cy="110"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-58">
              <g>
                <ellipse
                  cx="161"
                  cy="110"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-59">
              <g>
                <ellipse
                  cx="81"
                  cy="200"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-60">
              <g>
                <ellipse
                  cx="121"
                  cy="200"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-61">
              <g>
                <ellipse
                  cx="161"
                  cy="200"
                  rx="11.999999999999996"
                  ry="11.999999999999996"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-62">
              <g>
                <rect
                  x="-0.98"
                  y="0"
                  width="52"
                  height="40"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-63">
              <g>
                <rect
                  x="-0.98"
                  y="90"
                  width="52"
                  height="40"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-64">
              <g>
                <rect
                  x="-0.98"
                  y="180"
                  width="52"
                  height="40"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
